<template>
  <div class="home-container">
    <div class="home-content">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          @click="back"
          style="width: 90px"
          >返回</el-button
        >
      </div>
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="用户名称" align="center">
        </el-table-column>
        <el-table-column prop="headUrl" label="用户头像" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.headUrl" min-width="70" height="70" />
          </template>
        </el-table-column>        
        <el-table-column prop="content" label="评论内容" align="center">
        </el-table-column>        
        <el-table-column prop="createTime" label="评论时间" align="center">
        </el-table-column>     
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>                     
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
        <el-row>
            <el-col :span="24">
              <el-form-item label="问题名称" prop="name">
                <el-input
                  v-model="addData.name"
                  placeholder="请输入问题名称"
                ></el-input>
              </el-form-item> 
            </el-col>           
          </el-row>                                                
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>        
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
     activityId:Number   
    },
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      addData: {
        id: "",
        name:''
      },
      addDataRules: {
        name: [{ required: true, message: "请输入问题名称", trigger: "blur" }],
      },      
      isShowloading:false,
      isAddModal:false,
      btnLoading:false,
      modalTitle:""
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 返回活动列表
    back(){
        this.$emit('back',true)
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },  
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },  
    //删除
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.userCommentDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },    
    // 提交
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            voteId:this.voteId,
            name: this.addData.name
          };
          this.$Apis.voteAnswerAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },        
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    onLoad() {
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        communityServiceId:this.activityId
      }
      this.$Apis.commentcsList(data).then(res=>{
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style>
</style>